import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import * as iconSet from '@mdi/js';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';

const SmartIconButton = ({ onClick, iconPath, size, className, disabled }) => {
  const solvedIcon = iconSet[iconPath];
  return (
    <IconButton className={className} onClick={onClick} disabled={disabled}>
      <Icon path={solvedIcon} size={size} />
    </IconButton>
  );
};

SmartIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  iconPath: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.number,
  disabled: PropTypes.bool,
};

SmartIconButton.defaultProps = {
  size: 1,
  className: '',
  disabled: false,
};

export default SmartIconButton;
